export interface ObjectiveMenu {
  name?: string;
  inner_html?: string;
  alt?: string;
  image_url?: string;
  icon?: string;
  description?: string;
}

/**
 * The four things the platform actually does.
 *
 * The art is the demo's own subject set (assets/media/landing/subjects), taken
 * from the 2021 demo build and recoloured into the ink + spark palette. The
 * icons it replaced were single-tone lavender glyphs sitting in a lavender
 * well, which left them barely separable from their own background.
 *
 * The customer build promised "new exam papers every year" and "our team answers
 * within 24 hours" — commitments a demo cannot keep, describing one school
 * rather than the product. These describe capabilities a visitor can go and
 * click on, and each has a matching icon in the demo's own illustration set.
 */
export const ObjectiveMenuList: ObjectiveMenu[] = [
  {
    name: "วิดีโอบทเรียน",
    description: "ดูซ้ำได้ไม่จำกัด เรียนตามจังหวะของตัวเอง ระบบจำไว้ว่าดูค้างไว้ตรงไหน",
    image_url: "./assets/media/landing/subjects/laptop.svg",
    alt: "video lessons",
  },
  {
    name: "แบบฝึกหัดไม่ซ้ำเดิม",
    description: "สุ่มข้อจากคลังข้อสอบทุกครั้ง ทำใหม่ได้เรื่อย ๆ พร้อมเฉลยทันทีที่ส่ง",
    image_url: "./assets/media/landing/subjects/four-five-six.svg",
    alt: "quizzes",
  },
  {
    name: "รายงานรายบุคคล",
    description: "ครูเห็นว่านักเรียนแต่ละคนอ่อนหัวข้อไหน ไม่ใช่แค่คะแนนรวมของห้อง",
    image_url: "./assets/media/landing/subjects/analysis.svg",
    alt: "per-student report",
  },
  {
    name: "รู้ว่าควรทบทวนอะไร",
    description: "ระบบแนะนำหัวข้อที่ควรกลับไปทบทวน พร้อมชุดฝึกเฉพาะเรื่องและลิงก์ไปวิดีโอ",
    image_url: "./assets/media/landing/subjects/medal.svg",
    alt: "recommendations",
  },
];
